import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import Axios from 'axios';
import VueI18n from 'vue-i18n'

import router from './router'
import './icons'
import {EventBus} from '@/eventbus'

import en from '@/messages/en'
import de from '@/messages/de'

import AccountService from '@/api-services/account.service'
import apiutil from "@/util/apiutil";
import title_mixin from "@/mixins/title_mixin";

String.prototype.trim = function()
{
    return String(this).replace(/^\s+|\s+$/g, '');
};

(async () => {
    Vue.use(Vuex)
    Vue.use(BootstrapVue)
    Vue.use(BootstrapVueIcons)
    Vue.use(VueI18n)

    const i18n = new VueI18n({
        locale: 'de',
        fallbackLocale: 'en',
        messages: {'de': de, 'en': en}
    })


    Axios.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            // handle error
            if (error.response) {
                var stat = error.response.status
                switch (stat) {
                    case 401:
                        store.commit('logout')
                        router.push('/login')
                        break;
                    case 403:
                        store.commit('logout')
                        router.push('/login')
                        break;
                    default:
                        EventBus.$emit('api-error', error)
                        if ('error' in error.response.data) {
                            EventBus.$emit('alert', {variant: 'danger', message: 'errors.' + error.response.data.error})
                        } else {
                            EventBus.$emit('alert', {variant: 'danger', message: error})
                        }
                        break;
                }
            } else {
                alert(error)
            }
            return Promise.reject(error)
        });
    Vue.config.productionTip = false
    Axios.defaults.baseURL = '/api/';

    let user
    let admin = false
    try {
        user = (await AccountService.get_current_user()).data
    } catch {
        user = null
    }
    let ra = null
    if(user !== null) {
      ra = apiutil.dict_by_value_of_array(user.managing_room_access, 'id')
      admin = user.admin
    }
    const store = new Vuex.Store({
        state: {
            user: user,
            user_managing_room_access: ra,
            admin: admin,
            dorm: null
        },
        mutations: {
            set_dorm(state, payload) {
                state.dorm = payload
            },
            login(state, payload) {
                state.user = payload
                state.user_managing_room_access = apiutil.dict_by_value_of_array(state.user.managing_room_access, 'id')
                state.admin = payload.admin

            },
            logout(state) {
                state.user = null
                state.user_managing_room_access = null
                state.admin = false
                state.dorm = null
            },
        }
    })
    Vue.mixin(title_mixin)
    new Vue({
        i18n,
        router,
        store,
        render: h => h(App),
    }).$mount('#app')
})()
